import styles from "./PromptSection.module.css";
import { suggestPrompt } from "../../../asset";
import { useState, useEffect } from "react";
import { themeIcon } from "../../../asset";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import  PrayIcon  from "../../../asset/icons8-pray-96.png";
import MiracleIcon from "../../../asset/icons8-magic-wand-96.png";

const PromptSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [randPrompt, setRandPrompt] = useState([]);
  const icon = themeIcon();

  useEffect(() => {
    // Fixed two-card layout
    setRandPrompt([
      {
        id: "prayer",
        sort: "Prayer Requests",
        long: "Prayer Requests",
        icon: PrayIcon, // closest available to a prayer icon
      },
      {
        id: "miracle",
        sort: "Praise and Miracle Reports",
        long: "Praise and Miracle Reports",
        icon: MiracleIcon, // represents success/miracle
      },
    ]);
  }, []);

  const promptOnClick = (mainText) => {
    // dispatch(chatAction.suggestPromptHandler({ prompt: mainText }));
    try {
      if (mainText === "Prayer Requests") {
        navigate("/prayers");
        return;
      }
      if (mainText === "Praise and Miracle Reports") {
        navigate("/praise");
        return;
      }
      const form = document.querySelector('[id="input-form-chat"]');
      const input = document.querySelector('[id="input-form-chat"] input');
      if (form && input) {
        input.focus();
        // Highlight input with a temporary blue border and rounded ring
        form.classList.add('ring-2', 'ring-[#0285ff]', 'ring-offset-1', 'rounded-lg');
        setTimeout(() => {
          form.classList.remove('ring-2', 'ring-[#0285ff]', 'ring-offset-1', 'rounded-lg');
        }, 2000);
      }
    } catch {}
  };
  return (
    <div data-tour="suggested-prompts" className={`${styles["prompt-main"]}`}>
      {randPrompt.map((p) => (
        <div
          className={`${styles["prompt"]} animate-fadeInRight w-1/2`}
          key={p.id}
          onClick={() => promptOnClick(p.long)}
        >
          <p>{p.sort}</p>
          <div className={styles["icon"]}>
            {icon[p.icon] ? (
              <img src={icon[p.icon]} alt="icon"></img>
            ) : (
              <img src={p.icon} alt="icon"></img>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PromptSection;
